<template>
  <div>
    <HeadingSection
      v-if="title"
      class="mx-[24px] mb-[35px] sm:mx-[0] sm:px-0"
      :class="
        flushHeading
          ? ''
          : 'border-t border-gpx_gray-800 pt-[28px] sm:pt-[34px]'
      "
      :heading="title"
      :desc="subtitle"
      :button="topButton"
      :search="search"
      :filters="filters"
      :is-empty-data="isEmpty"
    />
    <DataTable
      v-if="!isEmpty"
      :loading="loading"
      :list="rows"
      :columns="columns"
      :truncate="truncate"
      :mode="mode"
      :routeName="routeName"
      :editActions="editActions"
      @itemClick="itemClick"
    />
    <DataTableNav v-if="paginationMeta && !isEmpty" v-model="pagination" :meta="paginationMeta" />
    <EmptyState
      v-if="isEmpty"
      class="mt-[35px]"
      type="table"
      :heading="
        isFiltered || isSearched ? `No results match` : `There is no ${title.toLowerCase()} yet`
      "
      :desc="
        isFiltered || isSearched
          ? 'The active filter is hiding all subscriptions'
          : 'They will appear later, based on actions.'
      "
    >
    </EmptyState>
  </div>
</template>

<script>
import * as _ from 'lodash'
import HeadingSection from '../elements/HeadingSection.vue'
import DataTable from '../elements/DataTable.vue'
import DataTableNav from '../elements/DataTableNav.vue'
import { TableResultsPerPage } from '@gpx-spa/constants'
import EmptyState from '../components/EmptyState.vue'

export default {
  components: {
    HeadingSection,
    DataTable,
    DataTableNav,
    EmptyState
  },

  props: {
    /** Drop the rule above the heading, for pages where it is the first thing on screen. */
    flushHeading: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      loading: false,
      ids: [],
      title: '',
      subtitle: '',
      columns: [],
      truncate: [],
      mode: '',
      routeName: '',
      editActions: [],

      pagination: { per_page: TableResultsPerPage[0], page: 1 },
      paginationMeta: {},
      search: {},
      filters: []
    }
  },

  computed: {
    id() {
      return this.$route.params.id
    },
    rows() {
      return _.map(this.itemsByIds(this.ids), (item, $index) => {
        return this.formatItemIntoRow(item, $index)
      })
    },
    topButton() {
      return null
    },
    isEmpty() {
      return this.rows.length === 0 && !this.loading
    },
    isFiltered() {
      return false
    },
    isSearched() {
      return false
    }
  },

  watch: {
    id: {
      handler() {
        this.loadPage()
      }
    },
    pagination: {
      deep: true,
      handler() {
        this.loadPage()
      }
    },
    search: {
      deep: true,
      handler() {
        this.pagination = { per_page: TableResultsPerPage[0], page: 1 }
      }
    },
    filters: {
      deep: true,
      handler() {
        this.pagination = { per_page: TableResultsPerPage[0], page: 1 }
      }
    }
  },

  mounted() {
    this.loadPage()
  },

  methods: {
    loadPage(page = null) {
      if (page) this.pagination.page = page

      this.loading = true
      const pagination = this.pagination
      const search = { query: this.search.value || null }
      const filters = this.filters.reduce((acc, item) => {
        acc[item.type] = item.value
        return acc
      }, {})

      this.fetchItems({ ...pagination, ...filters, ...search })
        .then((res) => {
          this.ids = _.map(res.data.data, (el) => el.id)
          this.paginationMeta = res.data.meta
        })
        .finally(() => {
          this.loading = false
        })
    },
    itemClick(item) {
      if(this.onItemClick) this.onItemClick(item);
    },
  }
}
</script>
